<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <z-page title="LAPORAN PENGGUNAAN HARIAN AIMS">
      <div class="table_scrol">
        <div class="w-card__content content-hardcode mb3" >
            <w-form v-model="valid" @validate="cari" ref="frm">
                <div style="font-size:20px;font-weight:bold; text-align:center">
                    LAPORAN PENGGUNAAN HARIAN AIMS
                </div>
                <div style="font-size:20px; text-align:center">
                    JABATAN PERKHIDMATAN VETERINAR MALAYSIA
                </div>
                <div style="font-size:20px; text-align:center;">
                    <span style="vertical-align:middle; font-size:20px;">
                        TARIKH JANA LAPORAN:
                    </span>
                    <w-input
                        type="date"
                        v-model="pencarian.tarikh"
                        style="width:150px; display:inline-block; vertical-align:middle; margin-left:8px;"
                    />
                </div>
               <!--  <div style="text-align:center; margin-top:20px;">
                    <w-button v-for="(tab, index) in tabs" :key="tab.key" class="mr2" :bg-color="activeTab === index ? 'primary' : 'secondary'" @click="activeTab = index" >
                        {{ tab.title }}
                    </w-button>
                </div> -->

                <br>
                <div style="font-size:20px; text-align:center">
                   <w-button bg-color="success" v-on="on" @click="createPdf()" class="mr2">
                        <w-icon class="mr1" md >fal fa-download</w-icon>Cetak Pdf
                    </w-button>
                </div>

                <div style="display:flex; justify-content:flex-end; align-items:center; gap:12px; margin-top:30px;">
                    <!-- Sebelumnya -->
                    <w-button bg-color="primary" :disabled="activeTab === 0" @click="prevTab" >
                        <!-- ⬅ -->
                        Sebelumnya
                    </w-button>

                    <!-- Indicator Tab -->
                    <div style="font-weight:bold;">
                         {{ activeTab + 1 }} dari {{ tabs.length }}
                     </div>

                    <!-- Selanjutnya -->
                    <w-button bg-color="primary" :disabled="activeTab === tabs.length - 1" @click="nextTab">
                        <!-- ➡ -->
                        Seterusnya
                    </w-button>
                </div>
            </w-form>
            <br>


<!-- tab 1 -->
            <div v-show="activeTab === 0">

                <div style="font-size:18px; font-weight:bold">
                    A. STATISTIK PENGGUNAAN SISTEM
                </div>
                <br>

                <div class="w-table-wrap" style="max-height: 900px;">
                    <div class="table-profil-scrol">
                    <table class="w-table" color="light" width="100%" style="border:1px solid #000; border-collapse: collapse;">
                        <thead>
                            <tr >
                                <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="1%" >
                                    BIL
                                </th>
                                <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%"  >
                                    ITEM
                                </th>
                                <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                                    BILANGAN
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="w-table__row" style="border: 1px solid #000;">
                                <td class="w-table__cell text-left" style="border: 1px solid #000;">i.</td>
                                <td class="w-table__cell text-left" style="border: 1px solid #000;">JUMLAH PENGGUNA BERDAFTAR</td>
                                <td class="w-table__cell text-center" style="border: 1px solid #000;">{{jumlah_user_daftar}}</td>
                            </tr>
                            <tr class="w-table__row" style="border: 1px solid #000;">
                                <td class="w-table__cell text-left" style="border: 1px solid #000;">ii.</td>
                                <td class="w-table__cell text-left" style="border: 1px solid #000;">PENGGUNA AKTIF HARIAN</td>
                                <td class="w-table__cell text-center" style="border: 1px solid #000;">{{pengguna_aktif_input}}</td>
                            </tr>
                            <tr class="w-table__row" style="border: 1px solid #000;">
                                <td class="w-table__cell text-left" style="border: 1px solid #000;">iii.</td>
                                <td class="w-table__cell text-left" style="border: 1px solid #000;">JUMLAH LOG MASUK SISTEM</td>
                                <td class="w-table__cell text-center" style="border: 1px solid #000;">{{jumlah_log_masuk}}</td>
                            </tr>
                            <tr class="w-table__row" style="border: 1px solid #000;">
                                <td class="w-table__cell text-left" style="border: 1px solid #000;">iv.</td>
                                <td class="w-table__cell text-left" style="border: 1px solid #000;">PURATA SESI SETIAP PENGGUNA</td>
                                <td class="w-table__cell text-center" style="border: 1px solid #000;">{{purata_sesi_pengguna}}</td>
                            </tr>
                            <!-- </template> -->
                        </tbody>
                    </table>

                     <br><br>
                    <div style="font-size:18px; font-weight:bold">
                        B. AKTIVITI OPERASI HARIAN
                    </div>
                    <br>
                    <div style="font-weight:bold">
                        i. PENDAFTARAN PREMIS
                    </div>
                    <br>

                    <table class="w-table" color="light" style="border:1px" width="100%">
                        <thead>
                            <tr>
                                <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="1%" >
                                    BIL
                                </th>
                                <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                                    NEGERI
                                </th>
                                <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                                    BILANGAN
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="premis_negeri.length == 0">
                                <tr class="w-table__row" >
                                    <td class="w-table__cell text-center" colspan="3"> Tiada Data.</td>
                                </tr>
                            </template>
                            <template  v-for="(dt, ind) in premis_negeri" :key="dt.id">
                                <tr class="w-table__row" style="border: 1px solid #000;">
                                    <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                        {{ind+1}}
                                    </td>
                                    <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                        {{dt.negeri ?? 0 }}
                                    </td>
                                    <td class="w-table__cell text-center" style="border: 1px solid #000;">
                                        {{dt.jumlah_premis ?? 0 }}
                                    </td>
                                </tr>
                            </template>
                                <tr>
                                    <td class="w-table__cell text-center" style="border:1px solid #000;" colspan="2">JUMLAH KESELURUHAN</td>
                                    <td class="w-table__cell text-center" style="border:1px solid #000;" > {{jumlah_keseluruhan}}</td>
                                </tr>
                        </tbody>
                    </table>
                    <br><br>
                    </div>
                </div>
            </div>

<!-- tab 2 -->
            <div v-show="activeTab === 1">
                <div style="font-size:18px; font-weight:bold">
                    ii. PENDAFTARAN TERNAKAN
                </div>
                <br>

                <div class="w-table-wrap" style="max-height: 900px;">
                    <div class="table-profil-scrol">
                        <table class="w-table" color="light" style="border:1px" width="100%">
                            <thead>
                                <tr>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="1%" >
                                        BIL
                                    </th>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="20%" >
                                        NEGERI
                                    </th>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="20%" >
                                        JENIS TERNAKAN
                                    </th>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="20%" >
                                        JURUSAN TERNAKAN
                                    </th>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                                        BAKA
                                    </th>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                                        BILANGAN
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                              <template v-if="ternakan_negeri.length == 0">
                                    <tr class="w-table__row" >
                                        <td class="w-table__cell text-center" colspan="6"> Tiada Data.</td>
                                    </tr>
                              </template>
                              <template v-for="(negeri, i) in ternakan_negeri" :key="negeri.id">
                        <!-- JIKA ADA TERNAKAN  -->
                                <template v-if="negeri.ternakan && negeri.ternakan.length">
                                    <template v-for="(dt, j) in negeri.ternakan" :key="j">
                                        <tr class="w-table__row" style="border:1px solid #000;">
                                            <td v-if="j === 0" :rowspan="negeri.ternakan.length" class="w-table__cell text-left" style="border:1px solid #000;"> 
                                                {{ i + 1 }}
                                            </td>
                                            <td v-if="j === 0" :rowspan="negeri.ternakan.length" class="w-table__cell text-left" style="border:1px solid #000;" >
                                                {{ negeri.negeri }}
                                            </td>
                                            <td class="w-table__cell" style="border:1px solid #000;">
                                                {{ dt.ternakan_nama }}
                                            </td>
                                            <td class="w-table__cell" style="border:1px solid #000;">
                                                {{ dt.jurusan_nama }}
                                            </td>
                                            <td class="w-table__cell" style="border:1px solid #000;">
                                                {{ dt.baka_nama }}
                                            </td>
                                            <td class="w-table__cell text-center" style="border:1px solid #000;">
                                                {{ dt.jumlah }}
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                        <!-- JIKA TIADA TERNAKAN -->
                                <template v-else>
                                    <tr class="w-table__row" style="border:1px solid #000;">
                                        <td class="w-table__cell text-left" style="border:1px solid #000;">
                                            {{ i + 1 }}
                                        </td>
                                        <td class="w-table__cell text-left" style="border:1px solid #000;">
                                            {{ negeri.negeri }}
                                        </td>
                                        <td class="w-table__cell" style="border:1px solid #000;" > - </td>
                                        <td class="w-table__cell" style="border:1px solid #000;" > - </td>
                                        <td class="w-table__cell " style="border:1px solid #000;" > - </td>
                                        <td class="w-table__cell text-center" style="border:1px solid #000;" >0</td>
                                    </tr>
                                </template>
                              </template>
                                    <tr>
                                        <td class="w-table__cell text-center" style="border:1px solid #000;" colspan="5">JUMLAH KESELURUHAN</td>
                                        <td class="w-table__cell text-center" style="border:1px solid #000;" > {{jumlah_keseluruhan_ternakan}}</td>
                                    </tr>
                            </tbody>
                        </table>
                        <br><br>
                    </div>
                </div>
            </div>

<!-- tab 3 -->
            <div v-show="activeTab === 2">
                <div style="font-size:18px; font-weight:bold">
                    iii. PERMOHONAN PERKHIDMATAN
                </div>
                <br>

                <div class="w-table-wrap" style="max-height: 900px;">
                    <div class="table-profil-scrol">
                        <table class="w-table" color="light" style="border:1px" width="100%">
                            <thead>
                                <tr>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="1%" >
                                        BIL
                                    </th>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="20%" >
                                        NEGERI
                                    </th>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="20%" >
                                        JENIS PERKJHIDMATAN
                                    </th>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                                        BILANGAN
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="perkhidmatan_negeri.length == 0">
                                    <tr class="w-table__row" >
                                        <td class="w-table__cell text-center" colspan="6"> Tiada Data.</td>
                                    </tr>
                                </template>
                                <template v-for="(negeri, i) in perkhidmatan_negeri" :key="negeri.id">
                        <!-- JIKA ADA TERNAKAN  -->
                                    <template v-if="negeri.art && negeri.art.length">
                                        <template v-for="(dt, j) in negeri.art" :key="j">
                                            <tr class="w-table__row" style="border:1px solid #000;">
                                                <td v-if="j === 0" :rowspan="negeri.art.length" class="w-table__cell text-left" style="border:1px solid #000;"> 
                                                    {{ i + 1 }}
                                                </td>
                                                <td v-if="j === 0" :rowspan="negeri.art.length" class="w-table__cell text-left" style="border:1px solid #000;" >
                                                    {{ negeri.negeri }}
                                                </td>
                                                <td class="w-table__cell" style="border:1px solid #000;">
                                                    {{ dt.lkp_art }}
                                                </td>
                                                <td class="w-table__cell text-center" style="border:1px solid #000;">
                                                    {{ dt.jumlah_art }}
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                </template>
                                <tr>
                                    <td class="w-table__cell text-center" style="border:1px solid #000;" colspan="3">JUMLAH KESELURUHAN</td>
                                    <td class="w-table__cell text-center" style="border:1px solid #000;" > {{jumlah_keseluruhan_perkhidmatan}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <br><br>
                    </div>
                </div>
            </div>

<!-- tab 4 -->
            <div v-show="activeTab === 3">

    <!-- PENSIJILAN BAKA  -->
                <div style="font-size:18px; font-weight:bold">
                    iv. PENSIJILAN BAKA
                </div>
                <br>
                <div style="font-size:18px; font-weight:bold">
                    a. PERMOHONAN PENSIJILAN BAKA
                </div>
                <br>

                <div class="w-table-wrap" style="max-height: 900px;">
                    <div class="table-profil-scrol">
                        <table class="w-table" color="light" style="border:1px" width="100%">
                            <thead>
                                <tr>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="1%" >
                                        BIL
                                    </th>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                                        NEGERI
                                    </th>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                                        BILANGAN
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="baka_negeri.length == 0">
                                    <tr class="w-table__row" >
                                        <td class="w-table__cell text-center" colspan="3"> Tiada Data.</td>
                                    </tr>
                                </template>
                                <template  v-for="(dt, ind) in baka_negeri" :key="dt.id">
                                    <tr class="w-table__row" style="border: 1px solid #000;">
                                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                            {{ind+1}}
                                        </td>
                                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                            {{dt.negeri ?? '-' }}
                                        </td>
                                        <td class="w-table__cell text-center" style="border: 1px solid #000;">
                                            {{dt.jumlah_baka ?? 0 }}
                                        </td>
                                    </tr>
                                </template>
                                    <tr>
                                        <td class="w-table__cell text-center" style="border:1px solid #000;" colspan="2">JUMLAH KESELURUHAN</td>
                                        <td class="w-table__cell text-center" style="border:1px solid #000;" > {{jumlah_keseluruhan_baka}}</td>
                                    </tr>
                            </tbody>
                        </table>
                        <br><br>
                    </div>
                </div>
                <br><br>

    <!-- BAKA ANAK  -->
                <div style="font-size:18px; font-weight:bold">
                    b. REKOD KELAHIRAN ANAK AI
                </div>
                <br>

                <div class="w-table-wrap" style="max-height: 900px;">
                    <div class="table-profil-scrol">
                        <table class="w-table" color="light" style="border:1px" width="100%">
                            <thead>
                                <tr>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="1%" >
                                        BIL
                                    </th>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                                        NEGERI
                                    </th>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                                        BILANGAN
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="baka_anak.length == 0">
                                    <tr class="w-table__row" >
                                        <td class="w-table__cell text-center" colspan="3"> Tiada Data.</td>
                                    </tr>
                                </template>
                                <template  v-for="(dt, ind) in baka_anak" :key="dt.id">
                                    <tr class="w-table__row" style="border: 1px solid #000;">
                                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                            {{ind+1}}
                                        </td>
                                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                            {{dt.negeri ?? '-' }}
                                        </td>
                                        <td class="w-table__cell text-center" style="border: 1px solid #000;">
                                            {{dt.jumlah_anak ?? 0 }}
                                        </td>
                                    </tr>
                                </template>
                                    <tr>
                                        <td class="w-table__cell text-center" style="border:1px solid #000;" colspan="2">JUMLAH KESELURUHAN</td>
                                        <td class="w-table__cell text-center" style="border:1px solid #000;" > {{jumlah_keseluruhan_anak}}</td>
                                    </tr>
                            </tbody>
                        </table>
                        <br><br>
                    </div>
                </div>

    <!-- BAKA PERUBAHAN -->

                <div style="font-size:18px; font-weight:bold">
                   c. PERMOHONAN PENGURUSAN PERUBAHAN
                </div>
                <br>

                <div class="w-table-wrap" style="max-height: 900px;">
                    <div class="table-profil-scrol">
                        <table class="w-table" color="light" style="border:1px" width="100%">
                            <thead>
                                <tr>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="1%" >
                                        BIL
                                    </th>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                                        NEGERI
                                    </th>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                                        BILANGAN
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="baka_perubahan.length == 0">
                                    <tr class="w-table__row" >
                                        <td class="w-table__cell text-center" colspan="3"> Tiada Data.</td>
                                    </tr>
                                </template>
                                <template  v-for="(dt, ind) in baka_perubahan" :key="dt.id">
                                    <tr class="w-table__row" style="border: 1px solid #000;">
                                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                            {{ind+1}}
                                        </td>
                                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                            {{dt.negeri ?? '-' }}
                                        </td>
                                        <td class="w-table__cell text-center" style="border: 1px solid #000;">
                                            {{dt.jumlah_perubahan ?? 0 }}
                                        </td>
                                    </tr>
                                </template>
                                    <tr>
                                        <td class="w-table__cell text-center" style="border:1px solid #000;" colspan="2">JUMLAH KESELURUHAN</td>
                                        <td class="w-table__cell text-center" style="border:1px solid #000;" > {{jumlah_keseluruhan_perubahan}}</td>
                                    </tr>
                            </tbody>
                        </table>
                        <br><br>
                    </div>
                </div>

            </div>


<!-- tab 5 -->
            <div v-show="activeTab === 4">

    <!-- PENGELUARAN -->

                <div style="font-size:18px; font-weight:bold">
                    v. PENGURUSAN SEMEN BEKU
                </div>
                <br>
                <div style="font-size:18px; font-weight:bold">
                    a. PENGELUARAN
                </div>
                <br>

                <div class="w-table-wrap" style="max-height: 900px;">
                    <div class="table-profil-scrol">
                        <table class="w-table" color="light" style="border:1px" width="100%">
                            <thead>
                                <tr>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="1%" >
                                        BIL
                                    </th>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                                        PERKARA
                                    </th>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                                        BILANGAN
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="pengeluaran.length == 0">
                                    <tr class="w-table__row" >
                                        <td class="w-table__cell text-center" colspan="3"> Tiada Data.</td>
                                    </tr>
                                </template>
                                <template  v-for="(dt, ind) in pengeluaran" :key="dt.id">
                                    <tr class="w-table__row" style="border: 1px solid #000;">
                                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                            {{ind+1}}
                                        </td>
                                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                            {{dt.pusat_benih ?? '-' }}
                                        </td>
                                        <td class="w-table__cell text-center" style="border: 1px solid #000;">
                                            {{dt.jumlah_pengeluaran ?? 0 }}
                                        </td>
                                    </tr>
                                </template>
                                    <tr>
                                        <td class="w-table__cell text-center" style="border:1px solid #000;" colspan="2">JUMLAH KESELURUHAN</td>
                                        <td class="w-table__cell text-center" style="border:1px solid #000;" > {{jumlah_keseluruhan_pengeluaran}}</td>
                                    </tr>
                            </tbody>
                        </table>
                        <br><br>
                    </div>
                </div>
                <br><br>

                <div style="font-size:18px; font-weight:bold">
                    b. PENDAFTARAN
                </div>
                <br>

                <div class="w-table-wrap" style="max-height: 900px;">
                    <div class="table-profil-scrol">
                        <table class="w-table" color="light" style="border:1px" width="100%">
                            <thead>
                                <tr>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="1%" >
                                        BIL
                                    </th>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                                        PERKARA
                                    </th>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                                        BILANGAN
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="pendaftaran.length == 0">
                                    <tr class="w-table__row" >
                                        <td class="w-table__cell text-center" colspan="3"> Tiada Data.</td>
                                    </tr>
                                </template>
                                <template  v-for="(dt, ind) in pendaftaran" :key="dt.id">
                                    <tr class="w-table__row" style="border: 1px solid #000;">
                                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                            {{ind+1}}
                                        </td>
                                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                            {{dt.pusat_benih ?? '-' }}
                                        </td>
                                        <td class="w-table__cell text-center" style="border: 1px solid #000;">
                                            {{dt.jumlah_pendaftaran ?? 0 }}
                                        </td>
                                    </tr>
                                </template>
                                    <tr>
                                        <td class="w-table__cell text-center" style="border:1px solid #000;" colspan="2">JUMLAH KESELURUHAN</td>
                                        <td class="w-table__cell text-center" style="border:1px solid #000;" > {{jumlah_keseluruhan_pendaftaran}}</td>
                                    </tr>
                            </tbody>
                        </table>
                        <br><br>
                    </div>
                </div>
                <br><br>


                <div style="font-size:18px; font-weight:bold">
                    c. PENGAGIHAN
                </div>
                <br>

                <div class="w-table-wrap" style="max-height: 900px;">
                    <div class="table-profil-scrol">
                        <table class="w-table" color="light" style="border:1px" width="100%">
                            <thead>
                                <tr class="w-table__row" style="border: 1px solid #000;">
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="1%" >
                                        BIL
                                    </th>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                                        PERKARA
                                    </th>
                                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                                        BILANGAN
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="pengagihan.length == 0">
                                    <tr class="w-table__row" style="border: 1px solid #000;" >
                                        <td class="w-table__cell text-center" colspan="3"> Tiada Data.</td>
                                    </tr>
                                </template>
                                <template  v-for="(dt, ind) in pengagihan" :key="dt.id">
                                    <tr class="w-table__row" style="border: 1px solid #000;">
                                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                            {{ind+1}}
                                        </td>
                                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                            {{dt.pusat_benih ?? '-' }}
                                        </td>
                                        <td class="w-table__cell text-center" style="border: 1px solid #000;">
                                            {{dt.jumlah_pengagihan ?? 0 }}
                                        </td>
                                    </tr>
                                </template>
                                    <tr>
                                        <td class="w-table__cell text-center" style="border:1px solid #000;" colspan="2">JUMLAH KESELURUHAN</td>
                                        <td class="w-table__cell text-center" style="border:1px solid #000;" > {{jumlah_keseluruhan_pengagihan}}</td>
                                    </tr>
                            </tbody>
                        </table>
                        <br><br>
                    </div>
                </div>
                <br><br>

            </div>



        </div>


        <br>
        <br>

      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import { GChart } from "vue-google-charts";

export default {
  extends: ZResource,
  props: {
    jumlah_user_daftar: [Array, Object],
    pengguna_aktif_input: [Array, Object],
    jumlah_log_masuk: [Array, Object],
    purata_sesi_pengguna: [Array, Object],
    premis_negeri: [Array, Object],
    jumlah_keseluruhan: [Array, Object],

    ternakan_negeri: [Array, Object],
    jumlah_keseluruhan_ternakan: [Array, Object],

    perkhidmatan_negeri: [Array, Object],
    jumlah_keseluruhan_perkhidmatan: [Array, Object],

    baka_negeri: [Array, Object],
    jumlah_keseluruhan_baka: [Array, Object],
    baka_anak: [Array, Object],
    jumlah_keseluruhan_anak: [Array, Object],
    baka_perubahan: [Array, Object],
    jumlah_keseluruhan_perubahan: [Array, Object],

    pengeluaran: [Array, Object],
    jumlah_keseluruhan_pengeluaran: [Array, Object],
    pendaftaran: [Array, Object],
    jumlah_keseluruhan_pendaftaran: [Array, Object],
    pengagihan: [Array, Object],
    jumlah_keseluruhan_pengagihan: [Array, Object],

    tarikhNow: [Array, Object]

  },
  


   components: {
        GChart
    },
  data() {
    return {
      resourceurl: 'laporan_pengguna.statistik_pengguna'+this.segmenName,
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Laporan Pengguna', route: '/laporan_pengguna' },
        { label: 'Statistik Pengguna', route: 'laporan_pengguna/statistik_pengguna' },
      ],
      // perPage: this.$page.props.items?.per_page || 1,
      form : this.datas,
      pencarian: {
         tarikh: this.tarikhNow ?? '',
      },

      activeTab: 0, // 0 = Tab A, 1 = Tab B
      tabs: [
        { key: 'statistik', title: 'STATISTIK PENGGUNAAN SISTEM' },
        { key: 'operasi', title: 'PENDAFTARAN TERNAKANN' },
        { key: 'perkhidmatan', title: 'PERMOHONAN PERKHIDMATAN' },
        { key: 'baka', title: 'PENSIJILAN BAKA' },
        { key: 'semen', title: 'PENGURUSAN SEMEN BEKU' },
      ],
     
      
    }
  },
  methods: {

  //   cetak(id)
  // {
  //     window.open('/baka/cetak/' + id, '_blank');
  // },
    

   createPdf() {
      const params = {
         tarikh: this.pencarian.tarikh || '',
         pdf: 1 // penanda untuk generate pdf
      };
      const queryString = new URLSearchParams(params).toString();
      const url = route('laporan_pengguna.statistik_pengguna') + '?' + queryString;
      window.open(url, '_blank');
   },


    cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       // params.page = 1;
       // params.per_page = this.perPage;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

    nextTab() {
        if (this.activeTab < this.tabs.length - 1) {
            this.activeTab++
        }
    },

    prevTab() {
        if (this.activeTab > 0) {
            this.activeTab--
        }
    },

    


  },

  computed: {
    tarikhJana() {
        const now = new Date()

        return now
        .toLocaleString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        })
        .replace(',', '')
    }
   },

   watch: {
    'pencarian.tarikh'(val) {
         clearTimeout(this._roleTimer)

         if (!val) {
            this.resetPencarian('pencarian')
            return
         }

         this._roleTimer = setTimeout(() => {
            this.$refs.frm.validate()
         }, 300)
      }
    
   },

  mounted() {
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>

<style>
.pagination {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
}

.pagination-btn {
  background-color: #007bff;
  color: white;
  padding: 5px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.pagination-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination-info {
  font-weight: bold;
}

.per-page-control {
  display: flex;
  align-items: center;
  gap: 8px;
}

.per-page-label {
  font-weight: 500;
  font-size: 14px;
  color: #333;
}

.per-page-select {
  padding: 5px 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 14px;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
}

.per-page-select:hover {
  border-color: #007bff;
  box-shadow: 0 0 4px rgba(0, 123, 255, 0.4);
}

/*.w-table thead tr:nth-child(1) th {
  position: sticky;
  top: 2px;
  background: #fff;
  z-index: 3;
}
*/
.w-table th,
.w-table td {
    border: 1px solid #000;
}
.w-table {
    border-collapse: collapse;
}

/* Header baris kedua */
/*.w-table thead tr:nth-child(2) th {
  position: sticky;
  top: 32px; 
  background: #fff;
  z-index: 2;
}*/

</style>
